<template>
  <el-select
    v-model="localValue"
    :size="size"
    :multiple="multiple"
    :disabled="disabled"
    :clearable="clearable"
    :placeholder="placeholder"
    @change="selected"
    filterable
  >
    <el-option
      key="null"
      label="Без категории"
      value="null"
    />
    <el-option
      v-for="cell in matrix.cells"
      v-if="matrix.setting.potential_size >= cell.column && matrix.setting.productivity_size >= cell.row"
      :key="cell.id"
      :label="cell.name"
      :value="cell.id"
    />
  </el-select>
</template>

<script>
export default {
  name: "talent-matrix-axis-cells-select",
  props: {
    matrix: {
      type: Object,
      default: {},
    },
    value: '',
    size: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: true },
    clearable: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Категории матрицы' },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
  },
  methods: {
    selected(value) {
      if (value === '') {
        value = null;
      }

      this.localValue = value;
      this.$emit('input', value);
      this.$emit('selected', value)
      this.$emit('change', value);
    },
  },
};
</script>

<style scoped>

</style>
